import { render, staticRenderFns } from "./NotificationPost.vue?vue&type=template&id=13aa033a&scoped=true&"
import script from "./NotificationPost.vue?vue&type=script&lang=js&"
export * from "./NotificationPost.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPost.vue?vue&type=style&index=0&id=13aa033a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa033a",
  null
  
)

export default component.exports